import { render, staticRenderFns } from "./TipoAttributoSelector.vue?vue&type=template&id=0fdbfe4e&"
import script from "./TipoAttributoSelector.vue?vue&type=script&lang=ts&"
export * from "./TipoAttributoSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
